import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { CORE_ATLAS_IMAGE } from "./assets";
import { applyEffectSettings, readStoredEffectSettings } from "./effects";
import "./styles.css";
import { applyFontScale, applyTheme, readStoredFontScale, readStoredTheme } from "./theme";

document.documentElement.style.setProperty("--core-atlas-image", `url("${CORE_ATLAS_IMAGE}")`);
applyTheme(readStoredTheme());
applyFontScale(readStoredFontScale());
applyEffectSettings(readStoredEffectSettings());

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
